type TimedService = { duration: number, amount: number, type: number }

const HANDS_TYPES = [1, 7, 8]
const FEET_TYPES = [2, 7, 9]
const OTHER_TYPES = [5, 6, 10]

const sumDuration = (services: TimedService[], types: number[]) => services
  .filter((service) => types.includes(service.type))
  .reduce((acc, service) => acc + service.duration * service.amount, 0)

/** Visit length in minutes: hands and feet are done at the same time, the rest follows */
export const calcDuration = (services: TimedService[]): number => {
  return Math.max(sumDuration(services, FEET_TYPES), sumDuration(services, HANDS_TYPES))
    + sumDuration(services, OTHER_TYPES)
}
